import useRouterStore from "stores/routerStore"

import useSubmitStore from "stores/submit"
import useT from "utils/useT"

const Description = () => {
  const t = useT()
  const locale = useRouterStore((state) => state.router?.locale)

  const setDescription = useSubmitStore((state) => state.setDescription)
  const submitterDescription = useSubmitStore(
    (state) => state.submitterDescription,
  )
  return (
    <>
      <div className="card card-style">
        <div className="content mb-0">
          <h3 dir="auto">{t.submit.description}</h3>
          <p dir="auto">{t.submit.descriptionSub}</p>
          <div className="input-style has-borders no-icon mb-4">
            <label htmlFor="description" className="color-highlight">
              {t.submit.description}
            </label>
            <textarea
              dir={locale?.includes("ar") ? "rtl" : "auto"}
              id="description"
              maxLength={1000}
              onChange={(e) => setDescription(e.target.value)}
              value={submitterDescription}
              placeholder={t.submit.descriptionInput}
              className="my-0 font-16"
              style={{
                height: "170px",
              }}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default Description
